<template>
  <div>
    <footer class="footer">
      <div class="clearfix"></div>
      <div class="icon-row">
        <div class="footer-icon">
          <h5 class="footer-icon-child"></h5>
          <span class="footer-icon-text">品类齐全，轻松购物</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-2"></h5>
          <span class="footer-icon-text">多仓直发，极速配送</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-3"></h5>
          <span class="footer-icon-text">正品行货，精致服务</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-4"></h5>
          <span class="footer-icon-text">天天低价，畅选无忧</span>
        </div>
      </div>
      <div class="service-intro">
        <div class="servece-type">
          <div class="servece-type-info" v-for="(guide, index) in guideArr" :key="index">
            <ul>
              <li v-for="(item, index) in guide" :key="index" @click="handleService(item)">{{item.label}}</li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="friend-link">
          <div class="friend-link-item">
            <ul>
              <li v-for="(link, index) in moreLink" :key="index">
                <span :class="[linkItemClass, {'link-last-item': index === 9}]" @click="$router.push({path: link.path})">{{link.label}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="copyright">
          <p>Copyright © 济南泉链海沃数字科技有限公司版权所有 | <a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备18041989号-1</a> | 增值电信业务经营许可证： <a href="https://dxzhgl.miit.gov.cn/#/home" target="_blank">鲁B2-20210662</a></p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      linkItemClass: 'link-item',
      guideArr: [
        [
          {
            label: '购物指南',
            path: null
          },
          {
            label: '支付方式',
            path: '/help/payment-methods'
          },
          {
            label: '发票申领',
            path: '/help/invoice-request'
          }
        ],
        [
          {
            label: '新手帮助',
            path: null
          },
          {
            label: '登录注册',
            path: '/help/login-reg'
          },
          {
            label: '用户协议',
            path: '/help/user-aggrement'
          },
          {
            label: '发布商品',
            path: '/help/post-product'
          },
          {
            label: '卖家须知',
            path: '/help/notes-for-sellers'
          }
        ],
        [
          {
            label: '关于我们',
            path: null
          },
          {
            label: '关于我们',
            path: '/help/about'
          },
          {
            label: '联系我们',
            path: '/help/contact'
          }
        ],
        [
          {
            label: '售后服务',
            path: null
          },
          {
            label: '退/换货',
            path: '/help/return-exchange'
          },
          {
            label: '取消订单',
            path: '/help/cancellation'
          }
        ],
        [
          {
            label: '配送方式',
            path: null
          },
          {
            label: '安全交易',
            path: '/help/secure-transaction'
          },
          {
            label: '隐私政策',
            path: '/help/privacy-policy'
          }
        ]
      ],
      moreLink: [
        {
          label: '商家入驻',
          path: '/apply'
        },
        {
          label: '关于我们',
          path: '/help/about'
        },
        {
          label: '联系我们',
          path: '/help/contact'
        },
        {
          label: '隐私政策',
          path: '/help/privacy-policy'
        }
      ]
    };
  },
  methods: {
    handleService (item) {
      if (item.path && this.$route.path !== item.path) {
        this.$router.push({path: item.path});
      }
    }
  }
};
</script>

<style scoped>
/*****************************底 部 开 始*****************************/
.footer {
  width: 100%;
  height: 304px;
  /* margin-top: 30px; */
  background-color: #eaeaea;
}
.icon-row {
  margin: 0 auto;
  /* padding-top: 8px; */
  width: 1000px;
  height: 64px;
}
.footer-icon {
  margin-left: 17px;
  margin-right: 17px;
  float: left;
}
.footer-icon-child {
  margin-top: 10px;
  overflow: hidden;
  position: absolute;
  width: 36px;
  height: 42px;
  background-image: url("../../../static/img/footer/ico_service.png");
  text-indent: -999px;
}
.footer-icon-child-2 {
  background-position: 0 -43px;
}
.footer-icon-child-3 {
  background-position: 0 -86px;
}
.footer-icon-child-4 {
  background-position: 0 -129px;
}
.footer-icon-text {
  margin-left: 45px;
  color: #444444;
  font-size: 18px;
  font-weight: bold;
  line-height: 64px;
}
.service-intro {
  width: 100%;
  border-top: 1px solid #b2dfdb;
}
.servece-type {
  margin: 15px auto;
  height: 150px;
  width: 800px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.servece-type-info {
  color: #666666;
}
.servece-type-info ul {
  list-style: none;
}
.servece-type-info li {
  font-size: 14px;
  cursor: pointer;
  line-height: 26px;
}
.servece-type-info li:first-child {
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
}
.friend-link {
  display: flex;
  align-items: center;
  /* width: 908px; */
  height: 30px;
  margin: 0px auto;
  color: #666;
  border-top: 1px solid #b2dfdb;
}
.friend-link-item {
  margin: 0px auto;
}
.friend-link-item ul {
  list-style: none;
}
.friend-link-item li {
  padding: 5px 0px;
  float: left;
}
.link-item {
  padding: 0px 8px;
  cursor: pointer;
  border-right: 1px solid #ccc;
}
.link-last-item {
  border: none;
}
.copyright {
  width: 100%;
  color: #666;
  line-height: 30px;
  text-align: center;
}
.copyright a{
  color: inherit;
  /* font-size: 20px; */
}

.copyright a:hover {
  color: blue;
}
/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue